import sabbar from "./sabbar.png"
import squadio from "./squadio.png"
import midaia from "./midaia.png"
import velents from "./velents.jpeg"

export const companiesLogos = {
    squadio: squadio,
    sabbar: sabbar,
    midaia: midaia,
    velents: velents
}

